import { Input } from "@/components/ui/input";
import { pageProblemText } from "@/lib/tina/festival-page";

interface PosterFieldProps {
  value: string;
  onChange: (url: string) => void;
}

/** Shown when no page Tina read has a poster: the curator pastes an image address. */
export function PosterField({ value, onChange }: PosterFieldProps) {
  return (
    <section className="flex flex-col gap-2 rounded-lg border p-4">
      <label htmlFor="festival-poster" className="text-sm font-medium">
        Poster image URL
      </label>
      <p className="text-sm text-muted-foreground">
        {pageProblemText("no_poster")}
      </p>
      <Input
        id="festival-poster"
        className="max-w-xl"
        placeholder="https://"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </section>
  );
}
